import { Form, FormInstance, Input, Typography } from 'antd';
import { MaskedInput } from 'antd-mask-input';
import React, { useContext, useEffect } from 'react';
import { MESSAGE_LENGTH } from '../virtual-assistant.constants';
import { EmailFormData } from '../vitrual-assistant.type';
import { localize } from '/react4xp/mixins/helpers';
import { PartContext } from '/react4xp/parts/virtual-assistant/virtual-assistant';

interface OperatorRequestFormProps {
    emailForm: FormInstance<EmailFormData>;
    setIsValid: React.Dispatch<React.SetStateAction<boolean>>;
    translations: any;
}

const OperatorRequestForm = ({ emailForm, setIsValid, ...props }: OperatorRequestFormProps) => {
    const values = Form.useWatch([], emailForm);
    const { translations } = useContext(PartContext);

    useEffect(() => {
        emailForm
            .validateFields()
            .then(() => {
                setIsValid(true);
            })
            .catch(() => setIsValid(false));
    }, [values]);

    return (
        <Form
            layout="vertical"
            form={emailForm}
            style={{ padding: '1rem 2rem 0' }}
            className="operator_form"
        >
            <Typography>{localize('form-title', translations)}</Typography>
            <Form.Item
                style={{
                    marginTop: 15
                }}
                label={localize('labels.fullname', translations)}
                name="name"
                rules={[
                    {
                        required: !values?.name,
                        message: localize('validation.contact', translations),
                    },
                ]}
            >
                <Input placeholder={localize('labels.enter-fullname', translations)} />
            </Form.Item>
            <Form.Item
                label={localize('labels.phone', translations)}
                name="phoneNumber"
                rules={[
                    {
                        required: !values?.email && !values?.phoneNumber,
                        message: localize('validation.contact', translations),
                    },
                    {
                        pattern: /^\+7 \(\d{3}\) \d{3}-\d{2}-\d{2}$/,
                        message: localize('validation.phone-format', translations),
                    },
                ]}
            >
                <MaskedInput
                    mask="+7 (000) 000-00-00"
                    placeholder={localize('placeholder.phone', props.translations)}
                />
            </Form.Item>
            <Form.Item
                label="Email"
                name="email"
                rules={[
                    {
                        required: !values?.phoneNumber && !values?.email,
                        message: localize('validation.contact', translations),
                    },
                    {
                        type: 'email',
                        message: localize('validation.email-format', translations),
                    },
                    // {
                    //     max: EMAIL_LENGTH,
                    //     message: localize('validation.email-length', translations),
                    // },
                ]}
            >
                <Input placeholder={localize('labels.enter-email', translations)} />
            </Form.Item>
            <Form.Item
                label={localize('labels.message', translations)}
                name="content"
                rules={[
                    {
                        required: !values?.content,
                        message: localize('validation.message', translations),
                    },
                    {
                        max: MESSAGE_LENGTH,
                        message: localize('validation.message-length', translations),
                    },
                ]}
            >
                <Input.TextArea />
            </Form.Item>
        </Form>
    );
};

export default OperatorRequestForm;
